import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { BundledTranslateLoader } from "./helper/bundled-translate.loader";
import { routes } from "./app.routes";
import { provideClientHydration } from "@angular/platform-browser";
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { authenticationInterceptor } from "./helper/http.Interceptor";

export function TranslateLoaderFactory() {
  return new BundledTranslateLoader();
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(withInterceptors([authenticationInterceptor])),
    TranslateModule.forRoot({
      defaultLanguage: "nl",
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
      },
    }).providers!,
    provideAnimationsAsync(),
    provideAnimationsAsync(),
  ],
};
